import apiClient from "./client";

export async function getTournamentTimezones() {
  return apiClient.get("/tournaments/meta/timezones");
}

export async function listTournaments({ status } = {}) {
  const params = status ? `?status=${encodeURIComponent(status)}` : "";
  return apiClient.get(`/tournaments${params}`);
}

export async function getTournament(slug) {
  return apiClient.get(`/tournaments/${slug}`);
}

export async function createTournament(body) {
  return apiClient.post("/tournaments", body);
}

export async function updateTournament(slug, body) {
  return apiClient.patch(`/tournaments/${slug}`, body);
}

export async function registerForTournament(slug, { isParticipant, isWitness }) {
  return apiClient.post(`/tournaments/${slug}/register`, { isParticipant, isWitness });
}

export async function withdrawFromTournament(slug) {
  return apiClient.delete(`/tournaments/${slug}/register`);
}

export async function suggestTournamentParticipants(slug, query = "") {
  const params = query ? `?q=${encodeURIComponent(query)}` : "";
  return apiClient.get(`/tournaments/${slug}/participants/suggest${params}`);
}

export async function addTournamentParticipant(slug, body) {
  return apiClient.post(`/tournaments/${slug}/participants`, body);
}

export async function generateBracket(slug) {
  return apiClient.post(`/tournaments/${slug}/bracket/generate`, {});
}

export async function getWitnessQueue(slug) {
  return apiClient.get(`/tournaments/${slug}/witness-queue`);
}

export async function getMatch(slug, matchId) {
  return apiClient.get(`/tournaments/${slug}/matches/${matchId}`);
}

export async function claimWitness(matchId) {
  return apiClient.post(`/tournaments/matches/${matchId}/claim-witness`, {});
}

export async function assignWitness(matchId, witnessPlayerId) {
  return apiClient.post(`/tournaments/matches/${matchId}/assign-witness`, { witnessPlayerId });
}

export async function reportMatch(matchId, body) {
  return apiClient.post(`/tournaments/matches/${matchId}/report`, body);
}

export async function setMatchAvailability(matchId, slots) {
  return apiClient.post(`/tournaments/matches/${matchId}/availability`, { slots });
}

export async function addMatchEvidence(matchId, body) {
  return apiClient.post(`/tournaments/matches/${matchId}/evidence`, body);
}

export async function deleteMatchEvidence(matchId, evidenceId) {
  return apiClient.delete(`/tournaments/matches/${matchId}/evidence/${evidenceId}`);
}

export async function suggestBracketParticipants(slug, query = "") {
  const params = query ? `?q=${encodeURIComponent(query)}` : "";
  return apiClient.get(`/tournaments/${slug}/participants/suggest-bracket${params}`);
}

export async function editMatchParticipant(matchId, body) {
  return apiClient.post(`/tournaments/matches/${matchId}/participant`, body);
}
